<template>
  <div class="global-search-map-container">
    <tabs
      :activeTab="0"
      :tabs="tabs"
      :center-tabs="false"
      :tabs-styling="tabsStyling"
      :tabs-labels-styling="tabsLabelsStyling"
    />

    <management-map :style="{ 'height': 'calc(100% - 50px)'}" />
  </div>
</template>

<script>
import ManagementMap from "@/newComponents/_Molecules/ManagementMap.vue";
import Tabs from "@/newComponents/_Atoms/Tabs.vue";

export default {
  name: "GlobalSearchMap",

  components: {
    ManagementMap,
    Tabs,
  },

  data() {
    return {
      tabs: [
        {
          label: this.$i18n.tc('Map', 1),
        },
      ],

      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '32px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
    }
  }
}
</script>

<style scoped>
.global-search-map-container {
  border-radius: 8px;
  padding: 18px;
  background-color: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  height: 100%;
}

.v-tabs >>> .v-tabs-bar {
  height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchMap.vue